import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { ComunicadoService } from '../service/comunicado.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-exibir',
  templateUrl: './exibir.component.html',
  styleUrls: ['./exibir.component.css']
})
export class ExibirComponent implements OnInit {

  @Input() comunicado: any = null;
  @Input() carregando: boolean = false;
  @Input() fabrica: boolean = false;
  @Output() marcarComoNaoLido = new EventEmitter<any>();

  mostrarTodosDestinatarios = false;
  maxDestinatariosVisiveis = 5;

  constructor(
    private service: ComunicadoService, 
    private translate: TranslateService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit() {
  }

  get formatoDataCompleto(): string {
    const idioma = this.translate.currentLang || this.translate.defaultLang;
    
    if (idioma === 'gb' || idioma === 'en') {
      // Formato americano: "Monday, October 9, 2025 at 4:22 PM"
      return "EEEE, MMMM d, y 'at' h:mm a";
    } else {
      // Formato brasileiro: "segunda-feira, 9 de outubro de 2025 às 16:22"
      return "EEEE, d 'de' MMMM 'de' y 'às' HH:mm";
    }
  }

  get localeAtual(): string {
    const idioma = this.translate.currentLang || this.translate.defaultLang;
    return (idioma === 'gb' || idioma === 'en') ? 'en-US' : 'pt-BR';
  }

  formatDate(dateString: string): Date {
    if (!dateString) return new Date();
    
    // Remover o [UTC] do final da string se existir
    const cleanDateString = dateString.replace(/\[UTC\]$/, '');
    
    // Criar a data e ajustar para o timezone local
    const date = new Date(cleanDateString);
    
    // Verificar se a data é válida
    if (isNaN(date.getTime())) {
      return new Date();
    }
    
    return date;
  }

  download(id: number) {
    const arquivo = this.comunicado.anexos.filter(p => p.id === id)[0];

    this.service.downloadDoArquivo(arquivo.chave, arquivo.tipo)
      .subscribe(res => {
        const newBlob = res;

        if (window.navigator && (window.navigator as any).msSaveOrOpenBlob) {
          (window.navigator as any).msSaveOrOpenBlob(newBlob);
          return;
        }

        const data = window.URL.createObjectURL(newBlob);

        const link = document.createElement('a');
        link.href = data;
        link.download = arquivo.nome;

        link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));

        setTimeout(function () {
          window.URL.revokeObjectURL(data);
          link.remove();
        }, 100);
      }
      );
  }


  getAttachmentClass(tipo: string): string {
    if ('xls_xlsx_csv'.includes(tipo)) {
      return 'xlsx';
    } else if ('doc_docx'.includes(tipo)) {
      return 'docx';
    } else if (tipo === 'txt') {
      return 'txt';
    } else if (tipo === 'pdf') {
      return 'pdf';
    } else {
      return 'outros';
    }
  }

  getAttachmentIcon(tipo: string): string {
    if ('xls_xlsx_csv'.includes(tipo)) {
      return 'far fa-file-excel';
    } else if ('doc_docx'.includes(tipo)) {
      return 'far fa-file-word';
    } else if (tipo === 'txt') {
      return 'far fa-file-alt';
    } else if (tipo === 'pdf') {
      return 'far fa-file-pdf';
    } else {
      return 'fas fa-file';
    }
  }

  private temDestinatarios(): boolean {
    return !!(this.comunicado && this.comunicado.destinatarios);
  }

  getDestinatariosParaExibir(): any[] {
    if (!this.temDestinatarios()) {
      return [];
    }
    
    if (this.mostrarTodosDestinatarios) {
      return this.comunicado.destinatarios;
    } else {
      return this.comunicado.destinatarios.slice(0, this.maxDestinatariosVisiveis);
    }
  }

  temMaisDestinatarios(): boolean {
    if (!this.temDestinatarios()) {
      return false;
    }
    return this.comunicado.destinatarios.length > this.maxDestinatariosVisiveis;
  }

  toggleMostrarTodos(): void {
    this.mostrarTodosDestinatarios = !this.mostrarTodosDestinatarios;
  }

  getTextoBotaoDestinatarios(): string {
    if (!this.temDestinatarios()) {
      return '';
    }
    const total = this.comunicado.destinatarios.length;
    const restantes = total - this.maxDestinatariosVisiveis;
    
    if (this.mostrarTodosDestinatarios) {
      return this.translate.instant('comunicado.exibir.mostrarMenos');
    } else {
      return `+${restantes} mais`;
    }
  }

  onMarcarComoNaoLido(): void {
    if (this.comunicado) {
      this.marcarComoNaoLido.emit(this.comunicado);
    }
  }
}

